import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class Term extends RESTSerializer {
  normalizeResponse(store, modelClass, payload) {
    // Terms are calculated, so there's only a list route - no individual GET to worry about.
    if (payload.terms) {
      payload.terms.forEach((el, idx) => {
        el.id = idx + 1;
        if (idx > 0) {
          el.previous = idx;
        }
      });
    }

    return super.normalizeResponse(...arguments);
  }
}
